import Accounts from './0_Accounts.js';
import Review from './1_Review.js';
import Migrate from './2_Migrate.js';

export default [
  Accounts,
  Review,
  Migrate,
];
